export const COLUMN_LAYOUT = 'columnLayout';
export const FULL_WIDTH_LAYOUT = 'fullWidthLayout';
